export const newFolderAnnouncementText = "y$R3Od";
export const renameFolderAnnouncementText = "OK2FFb";
export default {newFolderAnnouncementText,renameFolderAnnouncementText};